/*
 * This file has been generated by project-writer
 * Content Hash: 59fec4a5-045b-40fb-abcf-ccbcc5e93d8f
 */

/**
 * things your data can be related to
 */
export enum Entities {
  Position = "Position",
  Order = "Order",
  ImportProcess = "ImportProcess",
  UserOption = "UserOption",
  Preset = "Preset",
}
